(function () {
  // Today's Deals scheduling. Liquid sets data-td-start / data-td-end (epoch seconds, store
  // timezone already applied) and an initial data-td-live on cards, deal blocks and the campaign
  // hero. Shopify serves cached pages for a while, so this re-checks the visitor's clock on load,
  // every 30 seconds, and when the tab comes back into view. The theme editor never hides anything
  // (scheduled items carry a status tag there instead).
  if (window.__tdScheduleReady) return;
  window.__tdScheduleReady = true;

  // Liquid only prints data-td-editor inside the theme editor, so it doubles as a design-mode signal.
  var inEditor = !!(window.Shopify && window.Shopify.designMode) || !!document.querySelector('[data-td-editor]');

  function isLive(el) {
    return el.getAttribute('data-td-live') !== 'false';
  }

  // Without the filter pills on the page nobody else collapses a block whose cards are all off-schedule.
  function refreshBlocks() {
    if (document.querySelector('[data-td-filter]')) return;
    document.querySelectorAll('[data-td-promo-grid]').forEach(function (grid) {
      var cards = grid.querySelectorAll('.td-promo-card');
      var any = false;
      cards.forEach(function (c) { if (isLive(c)) any = true; });
      grid.classList.toggle('is-empty', cards.length > 0 && !any);
    });
  }

  function evaluate() {
    if (inEditor) return;
    var now = Date.now() / 1000;
    var changed = false;
    document.querySelectorAll('[data-td-start], [data-td-end]').forEach(function (el) {
      var start = parseFloat(el.getAttribute('data-td-start') || '0') || 0;
      var end = parseFloat(el.getAttribute('data-td-end') || '0') || 0;
      var live = (!start || now >= start) && (!end || now <= end);
      if (live !== isLive(el)) {
        el.setAttribute('data-td-live', live ? 'true' : 'false');
        changed = true;
      }
    });
    refreshBlocks();
    if (changed) document.dispatchEvent(new CustomEvent('td:schedule'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', evaluate);
  } else {
    evaluate();
  }
  setInterval(evaluate, 30000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) evaluate(); });
  document.addEventListener('shopify:section:load', evaluate);
})();
